import { getAdvanced } from '../../../helpers/utils';

export default node => {
    return {
        ...getAdvanced(node)
    };
};
